import track from 'lib/track';

function autoLocale(availableLocales) {
  const defaultLocale = 'en';

  try {
    const { languages } = navigator;

    // Exact matches
    // for (let i = 0; i < languages.length; i += 1) {
    //   if (availableLocales.indexOf(languages[i]) !== -1) {
    //     track('Locale', 'Auto', 'Exact', languages[i], { nonInteraction: true });
    //     return languages[i];
    //   }
    // }

    // Close matches
    for (let i = 0; i < languages.length; i += 1) {
      const result = availableLocales.find(l => languages[i].substr(0, 2) === l.substr(0, 2));
      if (result) {
        track('Locale', 'Auto', 'Close', result, { nonInteraction: true });
        return result;
      }
    }
  } catch (e) {
    track('Locale', 'Auto', 'Error', defaultLocale, { nonInteraction: true });
    return defaultLocale;
  }

  track('Locale', 'Auto', 'Error', defaultLocale, { nonInteraction: true });
  return defaultLocale;
}

export default autoLocale;



// WEBPACK FOOTER //
// ./src/lib/autoLocale.js